import React, { useState } from "react";
import { Button, Alert } from "react-bootstrap";
import { FaUpload } from "react-icons/fa";

const CSVUploader = ({ onUpload, isLoading }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setSelectedFile(null);
      setError("");
      return;
    }

    const allowedTypes = ['.csv', '.xlsx', '.ods'];
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

    if (!allowedTypes.includes(fileExtension)) {
      setError("Unsupported file type. Please upload CSV, XLSX, or ODS files.");
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
    setError("");
  };

  const handleImport = () => {
    if (selectedFile) {
      onUpload(selectedFile);
      setSelectedFile(null);
      setError("");
    }
  };

  return (
    <div className="file-uploader">
      <input
        type="file"
        accept=".csv,.xlsx,.ods"
        onChange={handleFileChange}
        disabled={isLoading}
        style={{ display: 'none' }}
        id="file-upload"
      />
      <label htmlFor="file-upload">
        <Button variant="outline-primary" as="span" disabled={isLoading}>
          <FaUpload className="me-2" />
          Choose File
        </Button>
      </label>

      {selectedFile && (
        <div className="mt-2">
          <small className="text-muted">Selected: {selectedFile.name}</small>
          <br />
          <small className="text-muted">File will be validated and imported on the server.</small>
          <br />
          <Button
            variant="success"
            size="sm"
            onClick={handleImport}
            disabled={isLoading}
            className="mt-1"
          >
            {isLoading ? "Importing..." : "Import Leads"}
          </Button>
        </div>
      )}

      {error && (
        <Alert variant="danger" className="mt-2 small">
          {error}
        </Alert>
      )}
    </div>
  );
};

export default CSVUploader;
